import { render, staticRenderFns } from "./Sep.vue?vue&type=template&id=086a333e&scoped=true"
import script from "./Sep.vue?vue&type=script&lang=js"
export * from "./Sep.vue?vue&type=script&lang=js"
import style0 from "./Sep.vue?vue&type=style&index=0&id=086a333e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a333e",
  null
  
)

export default component.exports